export function formatError(err: unknown): string {
  const ax = err as { response?: { data?: { detail?: string; title?: string } } }
  return ax.response?.data?.detail ?? ax.response?.data?.title ?? 'Błąd zapisu'
}

/** Product (element) codes are lowercase snake: fotowoltaika, magazyn, wiatrak... */
export const PRODUCT_CODE_REGEX = /^[a-z][a-z0-9_]{0,63}$/
